import { render, staticRenderFns } from "./Top500.vue?vue&type=template&id=c23a1618&scoped=true"
import script from "./Top500.vue?vue&type=script&lang=js"
export * from "./Top500.vue?vue&type=script&lang=js"
import style0 from "./Top500.vue?vue&type=style&index=0&id=c23a1618&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23a1618",
  null
  
)

export default component.exports